import { StyleProp, StyleSheet, Text, TextStyle, View } from "react-native";
import React from "react";
import { TextInput, useTheme } from "react-native-paper";

interface InputTextProps {
	placeholder?: string;
	style?: StyleProp<TextStyle>;
	value: string;
	onChange: (v: string) => void;
	secureTextEntry?: boolean;
	onBlur?: (v: any) => void;
	selectionColor?: string;
	textColor?: string;
	placeholderTextColor?: string;
	disabled?: boolean;
}

const InputText = (props: InputTextProps) => {
	const { colors } = useTheme();

	return (
		<TextInput
			style={[
				styles.root,
				{ backgroundColor: colors.inputBackgroundColor },
				props.style,
			]}
			placeholder={props.placeholder}
			underlineColor="transparent"
			activeUnderlineColor="transparent"
			placeholderTextColor={props.placeholderTextColor}
			value={props.value}
			onChangeText={props.onChange}
			secureTextEntry={props.secureTextEntry}
			autoCapitalize="none"
			onBlur={props.onBlur}
			selectionColor={props.selectionColor}
			textColor={props.textColor}
			disabled={props.disabled}
		/>
	);
};

export default InputText;

const styles = StyleSheet.create({
	root: {
		width: "90%",
		borderRadius: 25,
		borderTopLeftRadius: 25,
		borderTopRightRadius: 25,
		height: 50,
		paddingHorizontal: 24,
	},
});
